import { RootState } from "@/store/store";
import { aiKubernetesRecommendationsSelector } from "@/store/ai-kubernetes-recommendations/selectors/aiKubernetesRecommendationsSelector";

export const aiKubernetesRecommendationsLengthSelector = (
  state: RootState,
  resourceId?: string,
) => {
  return aiKubernetesRecommendationsSelector(state, resourceId)?.length ?? 0;
};
